// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA8kkIyzuOJbs5sLIBj5UlTnqAfofBDqp0",
  authDomain: "afrirate-1aa9a.firebaseapp.com",
  projectId: "afrirate-1aa9a",
  storageBucket: "afrirate-1aa9a.firebasestorage.app",
  messagingSenderId: "928287959371",
  appId: "1:928287959371:web:abc768c35f86e63feda0ce",
  measurementId: "G-0BVZX0LLDW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);